import en from './locales/en';
import fr from './locales/fr';
import de from './locales/de';
import nl from './locales/nl';
import it from './locales/it';

export default {
  en,
  fr,
  de,
  nl,
  it
};
